import React from "react";
import heroImage from "../assets/top-panel-background.jpg";
import logo from "../assets/logo.jpg";

const HeroSection = () => {
  return (
    <div className="bg-blue-900 py-16" id="home">
      <div className="lg:p-12">
        <div className="relative" style={{ height: "75vh" }}>
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src={heroImage}
              alt="Solar panels being installed"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-blue-900 to-transparent opacity-75"></div>
          </div>
          
          {/* Content Container */}
          <div className="relative z-10 max-w-6xl mx-auto px-2 md:px-6 h-full flex flex-col">
            {/* Logo */}
            <div className="pt-28">
              <img
                src={logo}
                alt="Sun Energy Logo"
                className="h-20 md:h-24 w-auto"
              />
            </div>
            
            <div className="mt-28 flex justify-center h-full">
              <div className="max-w-xl">
                <h2 className="text-orange-500 text-base sm:text-xl md:text-3xl font-bold tracking-wide font-geist">
                  FIRST IN MYANMAR
                </h2>
                <h1 className="text-white text-5xl md:text-7xl font-bold mt-4 font-geist">
                  Solar Panel
                  <br />
                  Maker
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
